import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { Lead, ModelID } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

interface UnsnoozeDTO {
  id: ModelID;
}

interface SnoozeDTO {
  id: ModelID;
  snooze_until: string;
}

const snooze = async ({ id, snooze_until }: SnoozeDTO) =>
  post<Lead>(`${featurePath}/${id}/snooze`, {
    snooze_until,
  });

const clearSnooze = async ({ id }: UnsnoozeDTO) =>
  post<Lead>(`${featurePath}/${id}/clear-snooze`, {});

export const useSnooze = (options?: UseUpdateMutationProps<Lead>) => {
  return useUpdateMutationFactory(
    {
      invalidateKeys: featureKeys,
      mutationFn: snooze,
      ...options,
    },
    { shouldInvalidateAll: false },
  );
};

export const useClearSnooze = (options?: UseUpdateMutationProps<Lead>) => {
  return useUpdateMutationFactory(
    {
      invalidateKeys: featureKeys,
      mutationFn: clearSnooze,
      ...options,
    },
    { shouldInvalidateAll: false },
  );
};
